/* DEMO: phone icon sits next to Help Centre; click opens popovers (phone number, bar items); click elsewhere or Esc closes.
   Also: the basket count "(1)" is mirrored into a round badge on desktop (the theme keeps updating the original, we just copy the number). When the basket is empty the button says "Cart empty". */
(function () {
  function place() {
    var ph = document.querySelector('.dc-ph');
    var help = document.querySelector('.dc-new [data-tip="Help Centre"]');
    var helpWrap = help && help.closest('.header-top-right-nav-bottom_nav');
    if (ph && helpWrap && helpWrap.parentNode && ph.nextElementSibling !== helpWrap) helpWrap.parentNode.insertBefore(ph, helpWrap);
  }
  place();
  document.addEventListener('DOMContentLoaded', place);

  function badge() {
    var src = document.querySelector('#main-nav-basket .item-count');
    if (!src) return;
    var box = document.getElementById('main-nav-basket');
    var b = src.parentNode.querySelector('.dc-count');
    if (!b) {
      b = document.createElement('span');
      b.className = 'dc-count';
      b.setAttribute('aria-hidden', 'true');
      src.parentNode.insertBefore(b, src.nextSibling);
      if (window.MutationObserver) new MutationObserver(sync).observe(src, { childList: true, characterData: true, subtree: true });
    }
    sync();
    function sync() {
      var n = (src.textContent || '').replace(/[^0-9]/g, '');
      b.textContent = n === '' ? '0' : n;
      if (box) box.classList.toggle('dc-empty', n === '' || parseInt(n, 10) === 0);
    }
  }
  badge();
  document.addEventListener('DOMContentLoaded', badge);

  function closeAll(except) {
    document.querySelectorAll('.dc-ph').forEach(function (w) {
      if (w === except) return;
      var b = w.querySelector('.dc-phbtn'), p = w.querySelector('.dc-pop');
      if (p) p.hidden = true; if (b) b.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.dc-bw').forEach(function (w) {
      if (w === except) return;
      var b = w.querySelector('.dc-bbtn'), p = w.querySelector('.dc-bpop');
      if (p) p.hidden = true; if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    var pbtn = t && t.closest('.dc-phbtn');
    var bbtn = t && t.closest('.dc-bbtn');
    var inPop = t && t.closest('.dc-pop, .dc-bpop');
    var wrap = pbtn ? pbtn.closest('.dc-ph') : bbtn ? bbtn.closest('.dc-bw') : null;
    if (!wrap) { if (!inPop) closeAll(null); return; }
    closeAll(wrap);
    var b = pbtn || bbtn, p = wrap.querySelector('.dc-pop, .dc-bpop');
    var open = p.hidden;
    p.hidden = !open;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();

/* 5 Nov (V4): footer guard. dc-mobile.js builds the footer once, when the page finishes parsing, as either the phone version or the desktop version depending on the screen width at that moment, and never looks again. If the width changes afterwards (phone turned sideways, in-app browsers such as Facebook and Instagram that report a wider screen at first, a page restored from the back button, a folding phone), the wrong footer is left on screen, which on a small phone shows as an oversized TikTok icon and plain stacked links. This checks after load, on rotation / resize and on page restore, and if the footer on screen is the wrong version for the screen width it reloads the page once (never more than once every 15 seconds, and not at all if the browser blocks session storage, so it cannot loop). */
(function () {
  var mq = window.matchMedia && window.matchMedia('(max-width: 767px)');
  if (!mq) return;
  function built() {
    var f = document.getElementById('footer');
    if (!f || !f.classList.contains('dc-fdone')) return null;
    return f.querySelector('.dc-fdesk') ? 'desk' : 'phone';
  }
  function check() {
    var b = built();
    if (!b || b === (mq.matches ? 'phone' : 'desk')) return;
    try {
      var k = 'dcFooterReload', last = +sessionStorage.getItem(k) || 0;
      if (Date.now() - last < 15000) return;
      sessionStorage.setItem(k, String(Date.now()));
    } catch (e) { return; }
    location.reload();
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(check, 250); }
  window.addEventListener('load', later);
  window.addEventListener('pageshow', function (e) { if (e.persisted) later(); });
  window.addEventListener('resize', later);
  window.addEventListener('orientationchange', later);
  if (mq.addEventListener) mq.addEventListener('change', later);
  else if (mq.addListener) mq.addListener(later);
})();
